<template>
  <div class="add-event">
    <button
      @click="showModal"
      v-tooltip="'Lisää uusi tapahtuma'"
      class="button button__circle"
    >
      <i class="icon icon--plus"></i>
    </button>
    <modal :isOpen="isOpen" @close="isOpen = false">
      <template v-slot:body>
        <form @submit.prevent="onSubmit">
          <Input
            type="text"
            name="title"
            label="Lisää otsikko"
            v-model="title"
            :hasError="errors.title"
          />
          <div class="radio-wrapper">
            <span class="radio-wrapper__title">
              Valitse kategoria:
            </span>
            <div class="radio-wrapper__row">
              <div
                v-for="(category, index) in company.categories"
                :key="index"
                class="radio-field"
              >
                <label class="radio-field__label">
                  {{ category.title }}
                  <input
                    type="radio"
                    :id="category"
                    :value="category"
                    v-model="selectedCategory"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <span v-if="errors.category" class="error">{{errors.category}}</span>
            </div>
          </div>
          <div class="date-wrapper">
            <Datepicker
              :icon="true"
              name="dateFrom"
              label="Tapahtuma alkaa"
              v-model="start"
              :hasError="errors.start"
            />
            <span class="line"></span>
            <Datepicker
              name="dateTo"
              label="Tapahtuma päättyy"
              v-model="end"
              :hasError="errors.end"
              :disabledBefore="start"
            />
          </div>
          <file-select
            folder="/files/"
            :action="fileUploadAction"
            @status-updated="onFileStatusUpdated"
          />
          <Textarea
            v-model="description"
            placeholder="Lisää kuvaus"
            name="description"
            :hasError="errors.description"
          />
          <button type="submit" class="button button__rounded button__submit">
            <span>Lisää uusi tapahtuma</span>
          </button>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import db from "@/firebase/init";
import moment from "moment";
import { mapState } from "vuex";
import slugify from "slugify";
import { validateField, validateDate } from "@/validation";

import Modal from "@/components/Modal";
import Input from "@/components/Input";
import Datepicker from "@/components/Datepicker";
import FileSelect from "@/components/FileSelect";
import Textarea from "@/components/Textarea";

export default {
  name: "EventForm",
  components: {
    Modal,
    Input,
    Datepicker,
    FileSelect,
    Textarea
  },
  data() {
    return {
      isOpen: false,
      title: null,
      start: null,
      end: null,
      selectedCategory: null,
      categories: [],
      file: null,
      fileUrlUploaded: null,
      fileUploadStatus: "init",
      fileUploadAction: "init",
      description: null,
      slug: null,
      active: false,
      errors: {},
      valid: true,
      sending: false,
      onHover: false,
      companyId: null
    };
  },
  computed: {
    ...mapState(["user", "company"]),
    today () {
      return moment(String(new Date())).format('DD.MM.YYYY');
    }
  },
  methods: {
    showModal(date) {
      if (typeof date === "string") {
        this.start = date;
      }
      this.isOpen = !this.isOpen;
    },
    validateForm() {
      this.errors = {};
      this.valid = true;
      // Title
      const validTitle = validateField(this.title);
      this.errors.title = validTitle.error;
      if (this.valid) {
        this.valid = validTitle.valid;
      }
      // Date from
      const validDateFrom = validateDate(this.start);
      this.errors.start = validDateFrom.error;
      if (this.valid) {
        this.valid = validDateFrom.valid;
      }

      // Date to
      const validDateTo = validateDate(this.end);
      this.errors.end = validDateTo.error;
      if (this.valid) {
        if(!moment(moment(this.start,'DD.MM.YYYY').toDate()).isBefore(moment(this.end,'DD.MM.YYYY').toDate())) {
          this.errors.end = "Päättymispäivämäärä ei voi olla ennen alkamispäivämäärää."
          this.valid = false;
        } else {
          this.valid = validDateTo.valid;
        }
      }
      // Category
      if (this.valid) {
        this.errors.category = "Tapahtumalla täytyy olla kategoria."
        this.valid = this.selectedCategory != null;
      }

      console.log("Is valid: ", this.valid);

      if (this.valid) return true;
    },
    onFileStatusUpdated(status) {
      console.log("Video status updtaed", status);
      switch (status.status) {
        case "ready_for_upload":
          this.fileUploadStatus = status.status;
          break;
        case "upload_complete":
          this.fileUrlUploaded = status.url;
          this.addEvent();
          break;
        case "error":
          console.log("status.error");
          break;
        default:
          break;
      }
    },
    onSubmit() {
      if (this.validateForm()) {
        console.log("validate ok, will upload file");
        if (this.fileUploadStatus === "ready_for_upload") {
          this.fileUploadAction = "upload";
          this.sending = true;
        } else {
          this.addEvent();
        }
      }
    },
    addEvent() {
      console.log("Save form to Firebase");
      this.slug = slugify(this.title, {
        replacement: "-",
        remove: /[$*_+~()'"!\-:@]/g,
        lower: true
      });

      const newEvent = {
        title: this.title,
        slug: this.slug,
        start: this.start,
        end: this.end,
        category: this.selectedCategory,
        fileUrlUploaded: this.fileUrlUploaded,
        description: this.description,
        createdAt: new Date()
      };

      db.collection(`companies/${this.company.id}/events`)
        .add(newEvent)
        .then(() => {
          console.log("Tapahtuma on nyt luotu");
          console.log(this.fileUrl);
          this.clearForm();
        })
        .catch(err => {
          console.log("Virhe tapahtui.", err);
        });
    },
    clearForm() {
      this.title = null;
      this.slug = null;
      this.start = null;
      this.end = null;
      this.selectedCategory = [];
      this.categories = [];
      this.errors = {};
      this.fileUrlUploaded = null;
      this.description = null;
      this.createdAt = null;
      this.isOpen = false;
    }
  },
  created() {
    setTimeout(() => {
      this.fileAction = "upload";
    }, 1000);
  }
};
</script>

<style lang="scss">
.radio-wrapper {
  padding: 5px 0 1em;
  &__title {
    font-size: 1.4rem;
    color: black;
  }
  &__row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 1em;
  }
}
.radio-field {
  margin-right: 1em;
  &__label {
    position: relative;
    display: block;
    padding-left: 2em;
    margin-bottom: 5px;
    cursor: pointer;
    font-size: 1.4rem;
    user-select: none;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      width: 0;
      height: 0;
      &:checked ~ .checkmark {
        background: $blue;
        &:after {
          display: block;
        }
      }
    }
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      width: 15px;
      height: 15px;
      background: $whitegray;
      box-shadow: $shadow_sm;
      border-radius: 50%;
    }
  }
}
</style>
